import { QuadrantModel } from './quadrant-model';

export interface SurveyResultModel {
  humility: QuadrantModel;
  love: QuadrantModel;
  pride: QuadrantModel;
  fear: QuadrantModel;
}
